/**
 * 入力された値を自動変換する関数
 */
export const inputAutoChange = () => {

  /**
   * フォーカスアウトで、ひらがなを全角カナへ変換
   */
  const fullPitchKana = document.querySelectorAll( 'input[data-full-pitch-kana]' ) || false;
  if ( fullPitchKana ) {
    fullPitchKana.forEach( target => {
      target.addEventListener( 'focusout', ( e ) => {
        const val = e.target.value;
        e.target.value = hiraToKana( val );
      } );
    } );
  }
}

/**
 * ひらがなをカタカナへ変換
 * @param { string } str
 * @returns { string }
 */
function hiraToKana(str) {
  return str.replace(/[\u3041-\u3096]/g, function(match) {
      var chr = match.charCodeAt(0) + 0x60;
      return String.fromCharCode(chr);
  });
}